import {gsap} from "../utils/vendor.js";

function openModal(complete) {
    complete.classList.add("-modal");

    gsap.to(complete, {
        opacity: 1,
        duration: 0.25,
        pointerEvents: "auto"
    });

    complete.querySelector("video").play();
}

function closeModal(complete) {
    complete.querySelector("video").pause();

    gsap.to(complete, {
        opacity: 0,
        duration: 0.25,
        pointerEvents: "none",
        onComplete: () => {
            complete.classList.remove("-modal");
        }
    });
}

function toggleShowreel(preview, complete) {
    gsap.to(preview, {
        opacity: 0,
        duration: 0.25,
        onComplete: () => {
            gsap.set(preview, {pointerEvents: "none"});
            gsap.set(complete, {pointerEvents: "auto"});
            gsap.fromTo(complete, {opacity: 0}, {opacity: 1, duration: 0.25});
            complete.querySelector('video').play();
        }
    });
}

function toggleBackToPreview(preview, complete) {
    complete.querySelector("video").pause();

    gsap.to(complete, {
        opacity: 0, duration: 0.25, pointerEvents: "none", onComplete: () => {
            gsap.set(complete, {pointerEvents: "none"});
            gsap.set(preview, {pointerEvents: "auto"});
            gsap.fromTo(preview, {opacity: 0}, {opacity: 1, duration: 0.25});
        }
    });
}

export default class ShowreelComponent {
    init() {
        document.querySelectorAll(".js-showreel").forEach(showreel => {
            const preview = showreel.querySelector(".js-showreel-preview");
            const complete = showreel.querySelector(".js-showreel-complete");
            const type = showreel.getAttribute("data-showreel") || "modal";

            preview.addEventListener("click", () => {
                if (type === "modal") {
                    openModal(complete);
                } else if (type === "toggle") {
                    toggleShowreel(preview, complete);
                }
            });

            complete.addEventListener("click", () => {
                if (type === "modal") {
                    closeModal(complete);
                } else if (type === "toggle") {
                    toggleBackToPreview(preview, complete);
                }
            });
        });
    }
}
